import ActStatusCircle from "../../../UIElements/StatusCircle";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import EnumsContext from "../../../../context/enums-context";
import useApi from "../../../../Utils/BackendClient";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import { useEnumLabel } from "../../../../Utils/Utils";

const ProductsTransfer = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { deleteMoveRemainingsAct, fetchMoveRemainingActs, finalizeMoveRemainingAct } = useApi();

    const enumTypes = useMemo(() => ["divisions"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);

    const [acts, setActs] = useState(null);
    const [lazyState, setLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "act_date",
        sortOrder: 1,
        filters: {}
    });
    const [loading, setLoading] = useState(true);
    const [reloadData, setReloadData] = useState(true);
    const [showFilters, setShowFilters] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        const fetchData = async () => {

            let state = lazyState;

            if (location?.state?.pageState) {
                state = location?.state?.pageState;
                setLazyState(location?.state?.pageState);

                location.state.pageState = null;

                navigate(location.pathname, { replace: true, state: location.state });
            }

            const response = await fetchMoveRemainingActs(state);

            if (response.status === 200) {

                setTotalRecords(response.data.count);
                setActs(response.data.results);

            }
            else {
                setActs([]);
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку актів", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            setLoading(false);
        }

        fetchData();

    }, [lazyState, fetchMoveRemainingActs, location, navigate, reloadData]);

    useEffect(() => {
        if (location.state?.toast) {
            toast.current.show(location.state.toast);

            location.state.toast = null;
            navigate(location.pathname, { replace: true, state: location.state});
        }
    }, [location.state, location, navigate]);

    const CreateNewSaleButtonHandler = () => {
        navigate("/productstransfer/newproductstransfer");
    }

    const onPage = (event) => {
        event.page = event.page + 1;
        setLazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setLazyState(event);
    }

    const onFilter = (event) => {
        //setTableFilters(event.filters);
    }

    const formatFilterChips = () => {

    };

    const DeleteButtonHandler = async (rowData) => {

        const response = await deleteMoveRemainingsAct(rowData.id);

        if(response.status === 204){
            setReloadData(!reloadData);
            toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Залишок успішно видалено', life: 3000 });
        }
        else{
            DisplayErrors(response.error, toast);
        }
    }

    const EditActHandler = rowData => {
        const route = '/productstransfer/productstransferdetails/' + rowData.id;
        navigate(route, { state: { id: rowData.id, pageState: lazyState } });
    }

    const FinalizeActHandler = async (rowData) => {

        const response = await finalizeMoveRemainingAct(rowData.id);

        if (response.status !== 200) {
            DisplayErrors(response.error, toast);
        }
        else {
            toast.current.show({ severity: 'success', summary: 'Фіналізація', detail: 'Акт фіналізовано', life: 3000 });
        }

        setReloadData(!reloadData);
    }

    const confirmDelete = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Підтвердіть видалення залишку контрагента',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { DeleteButtonHandler(rowData) }
        });
    }

    const confirmFinalize = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Після фіналізації акту, буде відсутня можливість його редагування',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { FinalizeActHandler(rowData) }
        });
    }

    const toolbarLeftTemplate = () => {
        return (isMobile && <Button icon={`${!showFilters ? "pi pi-filter" : "pi pi-filter-slash"}`} severity="secondary" outlined onClick={() => setShowFilters(!showFilters)} />)
    }

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Додати акт переміщення" severity="success" className={commonStyle.addButton} onClick={CreateNewSaleButtonHandler} />
        </div>)
    }

    const tableHeader = (
        <div className="flex justify-content-between align-items-center w-full">
            {formatFilterChips()}
        </div>
    );

    const actionBodyTemplate = (rowData) => {

        const isFinalized = rowData.status === "FINALIZED";

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-lock"
                className={`p-button-rounded ${!isFinalized ? "p-button-warning " + commonStyle.warningTag : commonStyle.closeButton}`}
                tooltip="Фіналізувати"
                disabled={isFinalized}
                tooltipOptions={{ showOnDisabled: true, position: "top" }}
                size="small"
                onClick={(event) => confirmFinalize(event, rowData)}
            />
            <Button
                icon="pi pi-trash"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                tooltip="Видалити"
                tooltipOptions={{ showOnDisabled: true, position: "top" }}
                size="small"
                onClick={(event) => confirmDelete(event, rowData)}
            />
            <Button
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                tooltip="Редагувати"
                tooltipOptions={{ position: "top" }}
                size="small"
                onClick={() => EditActHandler(rowData)}
            />
        </div>)
    }

    return (<>
        <Toast ref={toast} />
        <Toolbar start={toolbarLeftTemplate} end={toolbarRightTemplate} />
        <div className='grid'>
            <div className='col-12 justify-content-center'>
                <DataTable value={acts} header={tableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    removableSort first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]}
                    dataKey="id" onFilter={onFilter} filters={lazyState.filters} emptyMessage="Актів не знайдено" tableStyle={{ minWidth: '60rem' }} >
                    <Column field="act_number" header="Номер акту"  sortable style={{ width: '10%' }}/>
                    <Column field="act_date" dataType="date" header="Дата акту" sortable style={{ width: '15%' }}/>
                    <Column field="outcome_division_id" header="Точка продажу" sortable body={rowData => getDivisionLabel(rowData.outcome_division_id)} style={{ width: '20%' }}/>
                    <Column field="division_id" header="Точка продажу призначення" sortable body={rowData => getDivisionLabel(rowData.division_id)} style={{ width: '20%' }}/>
                    <Column field="status" header="Статус" sortable body={rowData => <ActStatusCircle rowData={rowData} />} />
                    <Column field="action" body={(rowData) => actionBodyTemplate(rowData)} style={{ width: '25%' }}/>  
                </DataTable>
            </div>
            <ConfirmDialog group="headless" />
        </div>
    </>)
}

export default ProductsTransfer;